import { LayoutStore } from './layout';
import { UserStore } from './user';
import { AuthenticateStore } from './authenticate';
import { PopupStore } from './popup';
import { observable } from 'mobx';


export const ROOT_STORE = 'rootStore';

export default class RootStore {
  public layoutStore: LayoutStore;
  public userStore: UserStore;
  public authenticateStore: AuthenticateStore;
  public popupStore: PopupStore;

  @observable public isLoading: boolean = false;

  constructor() {
    this.layoutStore = new LayoutStore(this);
    this.userStore = new UserStore(this);
    this.authenticateStore = new AuthenticateStore(this);
    this.popupStore = new PopupStore(this);
  }
}



// WEBPACK FOOTER //
// ./src/stores/rootStore.ts